$(function() {
  function showImages() {
    var windowHeight = jQuery( window ).height();
    $('.js-animation').each(function(){
        var thisPos = $(this).offset().top;

        var topOfWindow = $(window).scrollTop();
        if (topOfWindow + windowHeight - 200 > thisPos ) {
            $(this).addClass("animation-complete");
        }
      });
    }

    // if the image in the window of browser when the page is loaded, show that image
    $(document).ready(function(){
            showImages();
    });

    // if the image in the window of browser when scrolling the page, show that image
    $(window).scroll(function() {
            showImages();
    });

    // Add a class to trigger the start of animations
    function animateOnLoad() {
      var animateContainer = $('.js-animation--load');
      if (animateContainer.length) {
        $(animateContainer).addClass('animation-start');
      }
    }

    $(window).on('load', function() {
      animateOnLoad();
    });
});
